var map = {
	"./arrow.svg": 4028,
	"./check.svg": 1995,
	"./chevron-down.svg": 9015,
	"./cross.svg": 2039,
	"./link.svg": 3297,
	"./linkedin.svg": 8839,
	"./webatvantage.svg": 6188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;